<template>
	<div class="action-flow-node" style="height: 240px;">
		<div class="action-flow-title">Navigate</div>
		<div class="action-flow-hint">Browse the user to a different page, or component/data item.</div>
		
		<ActionParamHint label="Page" hint="What page to browse to, specifying a page will ignore this input." param-class="param-tgt"
			param-input-type="text"  param-input-label="Page" @param-change="handleParamChange"
			:param-input-value="parameters.page"
		/>
		<ActionParamHint label="Mote" hint="Mote to browse to, if applicable. If this mote is found, it will be selected or highlighted." param-class="param-tgt" />
		<ActionParamHint label="File" hint="File to browse to (download). If provided, page and mote navigation will be ignored." param-class="param-tgt" />
		<ActionParamHint label="Navigated" hint="Flow continues when page navigation is complete." param-class="param-src" />
		
		<Handle type="target" id="tgt-page" :position="Position.Left" style="top: 95px;" />
		<Handle type="target" id="tgt-mote" :position="Position.Left" style="top: 135px;" />
		<Handle type="target" id="tgt-file" :position="Position.Left" style="top: 175px;" />
		<Handle type="source" id="src-navigated" :position="Position.Right" style="top: 215px;" />
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	page: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			page: newNodeData.data?.page || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>
	